import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MySideBar from '../common/MySideBar';
import history from '../../common/history';
import TabWbsContainer from './TabWbsContainer';

export class DefaultPage extends Component {
  static propTypes = {
    wbs: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props){
    super(props);
    this.state = {
      project:null
    }
    //Si entra a la pagina sin saber que project está viendo lo manda a /
    if(!this.props.location || !this.props.location.state || !this.props.location.state.project )
      history.push("/");


  }

  render() {
    return (
      <div >
        <MySideBar style={{padding:"0px important!"}}>
          <TabWbsContainer  project={this.props.location.state? this.props.location.state.project: this.state.project}/>
        </MySideBar>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    wbs: state.wbs,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/wbs/DefaultPage.js